import React from 'react';
import styled from 'styled-components';
import useMobileOverlay from '../../../hooks/useMobileOverlay';
import TicketIcon from '../../../shared/components/Icons/Ticket';

const MobileOverlay = ({ onClick }) => {
  const { t } = useMobileOverlay();

  return (
    <Overlay onClick={onClick}>
      <ButtonContainer>
        <Button type="button">
          <Icon>
            <TicketIcon />
          </Icon>

          {t('selectTicket')}
        </Button>
      </ButtonContainer>
    </Overlay>
  );
};

export default MobileOverlay;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.24);
  z-index: 9991;
`;

const ButtonContainer = styled.div`
  position: absolute;
  top: 85%;
  transform: translateY(-85%);
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
`;

const Button = styled.button`
  background: ${({ theme }) => theme.buttonBackground || '#FFDA00'};
  border-radius: 8px;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  color: ${({ theme }) => theme.buttonColor || '#000'};
  border: 0;
  outline: none;
  padding: 14px;
  width: 100%;
  box-sizing: border-box;
`;

const Icon = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 7px;
`;
